<template>
  <div class="container sd-center m-auto sd-login">
    <div class="text-center">
      <h1 class="h3">Welcome!</h1>
      <p>Please enter your login credentials to continue</p>
    </div>
    <div class="row no-gutters sd-login__wrapper">
      <div class="col-lg-3 col-md-5 offset-lg-2 sd-login__map">
        <img src="@/assets/img/login_drone_on_map.svg" class="img-fluid" alt="Map Image">
      </div>
      <div class="col-lg-4 col-md-7 px-5 sd-login__form">
        <div class="text-center pt-4 pb-2">
          <img src="@/assets/img/logo_icon.svg" class="img-fluid" alt="">
        </div>
        <p class="text-primary sd-error-text h6 pt-2">{{loginError}}</p>
        <form class="sd-form">
          <div class="form-group">
            <!-- <label for="loginEmail">Email address</label> -->
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text sd-form__inputprepend sd-bg--gray">
                  <img src="@/assets/img/username_icon.svg" width="13px" class="img-fluid" alt="">
                </span>
              </div>
              <input type="email"
                    class="form-control sd-form__input sd-bg--gray"
                    aria-describedby="emailError"
                    placeholder="Username"
                    v-model="user.email">
              <small id="emailError" class="form-text text-muted"></small>
            </div>
          </div>
          <div class="form-group">
            <!-- <label for="loginPassword">Password</label> -->
            <div class="input-group sd-form__inputgroup">
              <div class="input-group-prepend">
                <span class="input-group-text sd-form__inputprepend sd-bg--gray">
                  <img src="@/assets/img/password_icon.svg" width="13px" class="img-fluid" alt="">
                </span>
              </div>
              <input type="password"
                    class="form-control sd-form__input sd-bg--gray"
                    placeholder="Password"
                    v-model="user.password">
            </div>
          </div>
          <div class="text-right sd-login__forgot">
            <a href="#" >Forgot Password?</a>
          </div>
          <button v-if="buttondisable" type="submit"
                  class="btn btn-primary text-uppercase sd-login__submit"
                  @click.prevent = "login" >Login</button>
          <button-spinner class="sd-spinner" v-if="isLogin"></button-spinner>
        </form>
      </div>
      </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import spinner from '@/components/spinner.vue';
export default {
  data() {
    return {
      user: {
        email: '',
        password: '',
      },
      loginError: '',
      isLogin:false,
      buttondisable:true,
    };
  },
  components:{
  'button-spinner':spinner
  },
  created:function(){
   document.title="Skylark Drones Inspection Portal";
  },
  methods: {
    ...mapActions([
      'retrieveAuthDetails',
    ]),
    login() {
      if(this.user.email!=''&&this.user.password!='')
      {
        this.isLogin=true;
        this.buttondisable=false;
      }
      // TODO: Perform General Validation
      this.retrieveAuthDetails(this.user)
        .then((response) => {
          if (response.status === 200) {
            if(response.data.is_staff) {
              localStorage.setItem('useremail',this.user.email);
              this.$router.push('/admin');
            } else {
               localStorage.setItem('useremail',this.user.email);
              this.$router.push('/dashboard');
            }
          }
        })
        .catch((error) => {
          if (error.response.status === 400) {
            this.loginError = 'Please Enter Valid Username & Password';
            this.isLogin=false;
            this.buttondisable=true;
          } else if (error.response.status === 500) {
            this.loginError = 'Internal Server Error. Please try again after sometime';
            this.isLogin=false;
            this.buttondisable=true;
          }
        });
    },
  },
};
</script>


<style lang="scss">

 @import '@/assets/sass/_variables.scss';

  .sd-center {
    position: absolute;
    top: 45%;
    left: 52%;
    transform: translate(-50%, -50%);
  }
  .sd-error-text {
    font-size: .8rem;
  }
  .sd-login{
    // padding-top: 10%;
    .sd-login__map{
    // box-shadow: 50px 50px 99px 0 rgba(0, 0, 0, 0.16);

        img{
        border-radius: .8rem 0 0 .8rem;
        box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
        }
    }

    .sd-login__form{
        background-color: $white;
        border-radius: 0 .8rem .8rem 0;
        // box-shadow: 50px 50px 99px 0 rgba(0, 0, 0, 0.16);
        box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
    }

    .sd-login__forgot {
        a {
        font-size: .8rem;
        font-weight: 500;
        color: $gray;
        }
    }

  .sd-login__submit{
    font-size: .8rem;
    font-weight: 500;
    letter-spacing: .09rem;
    }
  }
.sd-spinner{
  font-size:10px;
}
</style>
